import React, { useEffect, useState } from "react";
import { api, formatIDR } from "@/lib/api";
import { Building2, CreditCard, Eye, EyeOff, KeyRound, ShieldCheck, Store, Users as UsersIcon } from "lucide-react";

import PlatformBepCalculator from "@/components/PlatformBepCalculator";
import PlatformSettlementDashboard from "@/components/PlatformSettlementDashboard";
import PlatformOwnerProfile from "@/components/PlatformOwnerProfile";
export default function PlatformDashboard() {
  const [tenants, setTenants] = useState([]);
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    (async () => {
      const [t, p] = await Promise.all([api.get("/admin/tenants"), api.get("/plans")]);
      setTenants(t.data || []); setPlans(p.data || []);
    })();
  }, []);

  const active = tenants.filter((t) => t.subscription?.status === "active").length;
  const trial = tenants.filter((t) => t.subscription?.status === "trial").length;
  const mrr = tenants.reduce((s, t) => s + (t.plan?.price_monthly || 0), 0);

  return (
    <div className="p-6 lg:p-10">
      <div className="mb-8">
        <div className="overline text-zinc-500">PLATFORM OWNER</div>
        <h1 className="font-display font-black text-4xl lg:text-5xl tracking-tighter">Control Tower</h1>
        <p className="text-zinc-500 mt-1">Operasionalkan platform dan mitra Anda.</p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 grid-borders mb-10">
        {[
          { l: "Mitra Aktif", v: active, icon: Building2 },
          { l: "Trial Aktif", v: trial, icon: UsersIcon },
          { l: "Total Mitra", v: tenants.length, icon: Store },
          { l: "MRR Potensial", v: formatIDR(mrr), icon: CreditCard, raw: true },
        ].map((s) => (
          <div key={s.l} className="p-6 bg-white">
            <div className="flex justify-between items-start">
              <div className="overline text-zinc-500">{s.l}</div>
              <s.icon className="h-4 w-4 text-[#002FA7]"/>
            </div>
            <div className="mt-3 font-display font-black text-3xl lg:text-4xl tabular-nums">{s.raw?s.v:s.v}</div>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-0 grid-borders">
        <div className="p-6 bg-white">
          <div className="overline text-zinc-500 mb-4">MITRA TERBARU</div>
          <div className="space-y-3">
            {tenants.slice(0,8).map((t) => (
              <div key={t.id} className="flex items-center justify-between border-b border-border pb-2">
                <div>
                  <div className="font-semibold">{t.name}</div>
                  <div className="text-xs text-zinc-500">{t.outlets_count} outlet · {t.users_count} pengguna</div>
                </div>
                <div className="text-xs uppercase tracking-wider font-semibold">{t.subscription?.status || "-"}</div>
              </div>
            ))}
            {tenants.length===0 && <div className="text-sm text-zinc-500">Belum ada mitra.</div>}
          </div>
        </div>
        <div className="p-6 bg-white">
          <div className="overline text-zinc-500 mb-4">PAKET HARGA</div>
          <div className="space-y-3">
            {plans.map((p) => (
              <div key={p.id} className="flex items-center justify-between border-b border-border pb-2">
                <div>
                  <div className="font-semibold">{p.name}</div>
                  <div className="text-xs text-zinc-500">{p.max_outlets} outlet · {p.max_users} pengguna</div>
                </div>
                <div className="tabular-nums font-mono-num">{formatIDR(p.price_monthly)}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <PlatformBepCalculator />
      <PlatformSettlementDashboard />
      <PlatformOwnerProfile />
    </div>
  );
}